<div class="ng-autocomplete">
  <ng-autocomplete [data]="data" [searchKeyword]="keyword" (selected)='selectEvent($event)'
                   (inputChanged)='onChangeSearch($event)' (inputFocused)='onFocused($event)'
                   [itemTemplate]="itemTemplate" [notFoundTemplate]="notFoundTemplate" autofocus>
  </ng-autocomplete>

  <ng-template #itemTemplate let-item>
    <a [innerHTML]="item.name"></a>
  </ng-template>

  <ng-template #notFoundTemplate let-notFound>
    <div [innerHTML]="notFound"></div>
  </ng-template>
</div>
